import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @file Created on Wed Sep 19 2018
 * @author LZe
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { observable, action, computed } from 'mobx';
import { LoadingState } from '../api/LoadingState';
import rootStore from './RootStore';
import { StoreName } from './StoreName';
/**
 * The page store skeleton. It should be implemented by all page store classes.
 */

export var PageStore =
/*#__PURE__*/
function () {
  function PageStore() {
    var _this = this;

    _classCallCheck(this, PageStore);

    this.messages = rootStore.getStore(StoreName.Message); // Change this state when all data are ready (or fetching failed).

    this.loadingState = LoadingState.Pending;
    /**
     * Variable mainly used for permission control
     * [Example]: If user dont have permissions for page editing,
     * just set readOnly to {true} value, and control your field/actions on your page
     */

    this.pageReadOnly = false;
    /**
     * Used for handling page errors. Use this.errors.set(error) in the API call catch(error) statement
     * Example:
     *
     * this.competitorSites
     *   .toggleActive(selectedCompetitorsIds, isSomeNotActive)
     *   .then(() => this.setLoadingState(LoadingState.Success))
     *   .catch((error) => {
     *     this.setLoadingState(LoadingState.Error);
     *     this.errors.set(error);
     *   });
     *
     */

    /**
     * Changes loading state
     * @param state should represent data
     */

    this.setLoadingState = function (state) {
      _this.loadingState = state;
    };
    /**
     * Changes readOnly state
     * @param state new readOnlyState
     */


    this.setReadOnly = function (state) {
      _this.pageReadOnly = state;
    };
  }
  /** Return true if Page is loaded */


  _createClass(PageStore, [{
    key: "isLoadingSuccess",
    get: function get() {
      return this.loadingState === LoadingState.Success;
    }
  }]);

  return PageStore;
}();

__decorate([observable, __metadata("design:type", Number)], PageStore.prototype, "loadingState", void 0);

__decorate([observable, __metadata("design:type", Boolean)], PageStore.prototype, "pageReadOnly", void 0);

__decorate([computed, __metadata("design:type", Object), __metadata("design:paramtypes", [])], PageStore.prototype, "isLoadingSuccess", null);

__decorate([action, __metadata("design:type", Object)], PageStore.prototype, "setLoadingState", void 0);

__decorate([action, __metadata("design:type", Object)], PageStore.prototype, "setReadOnly", void 0);